type VerticalCenterProps = {
  children?: React.ReactNode;
};

const VerticalCenter = (props: VerticalCenterProps) => {
  return <div className="verticalCenter">{props.children}</div>;
};

export default VerticalCenter;
